import React from 'react';
import classes from './index.module.scss';
import { Container, Col, Row } from 'react-bootstrap';
import CountUp from 'react-countup';
import { Swiper, SwiperSlide } from 'swiper/react';
import BannerOne from '../../../assets/images/banner-1.jpg';
import BannerTwo from '../../../assets/images/banner-2.jpg';
import BannerThree from '../../../assets/images/banner-3.jpg';
import SwiperCore, { Autoplay } from 'swiper';

SwiperCore.use([Autoplay])

const SLIDER_LIST = [
  BannerOne,
  BannerTwo,
  BannerThree
]

const Banner = ({ federalContractsTotalCount }) => {
  return (
    <Swiper
      className={classes.Swiper}
      effect="fade"
      slidesPerView={1}
      loop={true}
      speed={500}
      parallax={true}
      autoplay={{
          delay: 5000,
          disableOnInteraction: false
      }}
    >
      {SLIDER_LIST.map((item, index) => {
        return (
          <SwiperSlide key={item + index} className={classes.Banner} style={{ backgroundImage: `url(${item})`}}></SwiperSlide>
        )
      })}
      <div className={classes.Overlay}>
        <Container>
          <Row>
            <Col>
              <h1 className={classes.Banner_Title}>
                Match and Search
              </h1>
              <p className={classes.Banner_Sub_Title}>
                more than
                {" "}
                <b>
                  <CountUp
                    start={20000}
                    end={federalContractsTotalCount}
                    separator=","
                    duration={2}
                  />
                </b>
                {" "}
                Contract Opportunities
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </Swiper>
  )
}

export default Banner;